import { Button, Popover, Space, Divider, QRCode } from '@didi-pebble/pebble-design-react';
import envConfig from 'env';
import { i18nTranslate } from '@didi/i18n-plugin';
import { useAtomValue } from 'jotai';

import { loginInfoAtom } from '@/store/common';
import scan from '@/assets/images/newScan.png';
import { Omega } from '@/lib';

import styles from './index.module.less';

const CodeInfo: React.FC = () => {
  const loginInfo: any = useAtomValue(loginInfoAtom);

  const doDownload = (url: string, fileName: string) => {
    const a = document.createElement('a');

    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadCanvasQRCode = () => {
    const canvas = document.getElementById('myqrcode')?.querySelector<HTMLCanvasElement>('canvas');

    if (canvas) {
      const url = canvas.toDataURL();

      doDownload(url, '99Abastece.png');
    }
    Omega.trackEvent('ibt_gd_gas_station_business_cs_qrcode_download_ck', '二维码下载点击', {
      user_id: loginInfo?.uid,
      country_code: loginInfo?.country_code
    });
  };
  const handleMouseEnter = () => {
    Omega.trackEvent('ibt_gd_gas_station_business_cs_qrcode_sw', '二维码展示', {
      user_id: loginInfo?.uid,
      country_code: loginInfo?.country_code
    });
    Omega.trackEvent('ibt_gd_gas_station_business_cs_qrcode_download_sw', '二维码下载展示', {
      user_id: loginInfo?.uid,
      country_code: loginInfo?.country_code
    });
  };

  return (
    <div onMouseEnter={handleMouseEnter}>
      <Popover
        overlayClassName={styles.pop_content}
        content={
          <div className='w-[150px] p-0 flex justify-center items-center font-DiDiSansPro-Medium text-xs'>
            <Space className='items-center' id='myqrcode' direction='vertical'>
              <QRCode className='p-0' value={envConfig.FLEET_API_URL} bordered={false} size={160} />

              <div className={`text-center w-[125px]  leading-none  `}>
                {i18nTranslate('Internal_Tools_2_CrYy_JcNy')}
              </div>
              <Divider className='w-[144px]' style={{ marginTop: 5, marginBottom: 0 }} />
              <Button
                className='flex justify-center items-center font-DiDiSansPro-Medium text-xs'
                type='primary'
                onClick={downloadCanvasQRCode}
              >
                <div className={`shrink-0 ${styles.bg_img}`} />
                <div className='text-xs'>{i18nTranslate('Internal_Tools_2_kwTR_iKCb')}</div>
              </Button>
            </Space>
          </div>
        }
        placement='bottom'
      >
        <div className={styles.pop_over}>
          <div className=' h-[35px] flex items-center rounded'>
            <div className='px-[8px] flex items-center justify-center rounded font-DiDiSansPro-Medium text-xs'>
              <img src={scan} width={20} height={20} className='mr-[8px] shrink-0' />

              <div className='font-medium'>{i18nTranslate('Internal_Tools_2_QKQx_ephy')}</div>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default CodeInfo;
